var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "textarea-wrapper", class: { active: _vm.isActive } },
    [
      _c("span", { staticClass: "placeholder" }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _c("textarea", {
        ref: "area",
        attrs: { name: "text", maxlength: "270" },
        domProps: { value: _vm.value },
        on: {
          focus: _vm.focus,
          blur: _vm.blur,
          input: _vm.handleInput,
          keyup: _vm.keyUp,
        },
      }),
      _vm._v(" "),
      _c("textarea", {
        ref: "harea",
        staticClass: "h",
        attrs: { name: "textcopy", maxlength: "270" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }